import { useNavigate } from "react-router-dom";
import { AlertTriangle } from "lucide-react";

const NotFoundPage = () => {
  const navigate = useNavigate();

  return (
    <div className="flex flex-col items-center justify-center min-h-screen bg-gray-100 p-4">
      <AlertTriangle className="text-red-500 w-16 h-16 mb-4" />
      <h1 className="text-6xl font-bold text-red-500 mb-4">404</h1>
      <p className="text-center text-xl text-gray-700 mb-6">
        Oops! The page you're looking for doesn't exist.
      </p>
      <button
        onClick={() => navigate("/")}
        className="bg-blue-500 text-white px-4 py-2 rounded-lg shadow hover:bg-blue-600 transition duration-300"
      >
        Go Back Home
      </button>
    </div>
  );
};

export default NotFoundPage;
